import { X } from "lucide-react";
import React, { useCallback, useRef, useState } from "react";

// Drag & drop + custom button uploaderTwo (no Tailwind)
// - Pure React + custom CSS
// - Files stored in state (single file)
// - Validates file types: video, image, audio, ppt/pptx, pdf, zip only
// - Ready to send over API (FormData example included)

export default function FileDropzoneUploaderTwo({progress, type = "image" ,filesBack }) {
   const [files, setFiles] = useState([]);
   const [isDragging, setIsDragging] = useState(false);
   const [errors, setErrors] = useState([]);
   const inputRef = useRef(null);
 
   // Allowed type mapping
   const typeMap = {
     image: {
       mime: ["image/jpeg", "image/png", "image/gif", "image/webp", "image/bmp", "image/svg+xml", "image/heic", "image/heif"],
       ext: /\.(jpe?g|png|gif|webp|bmp|svg|heic|heif)$/i,
       accept: "image/*",
       label: "images"
     },
     audio: {
       mime: ["audio/mpeg", "audio/mp3", "audio/wav", "audio/ogg", "audio/aac", "audio/flac", "audio/webm"],
       ext: /\.(mp3|wav|ogg|aac|flac|mpe?g|webm)$/i,
       accept: "audio/*",
       label: "audio"
     },
     video: {
       mime: ["video/mp4", "video/quicktime", "video/x-msvideo", "video/x-matroska", "video/webm", "video/ogg"],
       ext: /\.(mp4|mov|avi|mkv|webm|ogg)$/i,
       accept: "video/*",
       label: "video"
     },
     pdf: {
       mime: ["application/pdf"],
       ext: /\.pdf$/i,
       accept: ".pdf",
       label: "PDF"
     },
     ppt: {
       mime: ["application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
       ext: /\.pptx?$/i,
       accept: ".ppt,.pptx",
       label: "PowerPoint"
     },
     zip: {
       mime: ["application/zip", "application/x-zip-compressed", "multipart/x-zip", "application/x-zip"],
       ext: /\.zip$/i,
       accept: ".zip",
       label: "ZIP"
     }
   };
 
   const activeType = typeMap[type] || typeMap.image;
 
   const isAllowed = (file) => {
     if (file.type && activeType.mime.includes(file.type)) return true;
     return activeType.ext.test(file.name);
   };
 
   const signature = (f) => `${f.name}-${f.size}-${f.lastModified}`;
 
   const onFilesSelected = useCallback((list) => {
     if (!list || list.length === 0) return;
     const file = list[0]; // only one file allowed
 
     if (isAllowed(file)) {
       // console.log([file])
       setFiles([file]); filesBack([file])
     } else {
       setErrors((prev) => [...prev, `Rejected: ${file.name} — not an allowed ${activeType.label} file`]);
     }
   }, [activeType]);
 
   const handleDrop = useCallback((e) => {
     e.preventDefault();
     e.stopPropagation();
     setIsDragging(false);
     if (e.dataTransfer?.files?.length) onFilesSelected(e.dataTransfer.files);
   }, [onFilesSelected]);
 
   const handleDragOver = useCallback((e) => {
     e.preventDefault();
     e.stopPropagation();
     e.dataTransfer.dropEffect = "drop";
     setIsDragging(true);
   }, []);
 
   const handleDragLeave = useCallback((e) => {
     e.preventDefault();
     e.stopPropagation();
     setIsDragging(false);
   }, []);
 
   const openFileDialog = () => {inputRef.current?.click();if(files?.length){ upload()}}
 
   const removeFile = () => {
     setFiles([]);
   };
 
   const clearErrors = () => setErrors([]);
 
   const upload = async () => {
     if (files.length === 0) return alert(`Please select a ${activeType.label} file.`);
 
     const form = new FormData();
     form.append("file", files[0], files[0].name);
 
     try {
       const res = await fetch("/api/upload", { method: "POST", body: form });
       if (!res.ok) throw new Error(`Upload failed: ${res.status}`);
       const data = await res.json().catch(() => ({}));
       alert("Uploaded successfully!" + JSON.stringify(data, null, 2));
     } catch (err) {
       console.error(err);
       alert(err?.message || "Upload failed");
     }
   };
  return (
    <div className="uploaderTwo">
      <style>{`
        .uploaderTwo { overflow:hidden; display: flex;justify-content:center;    }
        .uploaderTwo__wrap {  }
        
        .uploaderTwo__title { font-size: 24px; font-weight: 600; margin: 0; }
        .uploaderTwo__subtitle { font-size: 14px; color: #5f6368; margin-top: 6px; }
        .dropzoneTwo {left:40%; z-index:1;transition:1s ease;position: absolute; border: 6px dashed #bcd3f5ff; border-radius: 16px;height: 180px;width:180px; border-radius:50%; background: #fff; padding: 6px; text-align: center; cursor: pointer; transition: box-shadow .2s, border-color .2s, background .2s; box-shadow: 0 1px 3px rgba(16,24,40,.06);bottom:-50px;}
        .dropzoneTwo:hover {transition:1s ease;box-shadow: 0 4px 12px rgba(16,24,40,.08); }
        .dropzoneTwo.is-dragging {transition:0.51s ease;background: #eef2ff; border-color: #6366f1; }
        .dropzoneTwo__icon { width: 44px; height: 44px; opacity: .7; margin: 0 auto 8px; display: block; color: #111; }
        .btnTwo { display:inline-flex; align-items:center; justify-content:center; padding: 10px 16px; border-radius: 14px; border: 2px solid #7badfeff; background:rgba(144, 202, 249,1); color:#fff; font-weight: 600; cursor: pointer; transition: transform .05s ease, background .2s;margin-top: 6px; }
        .btnTwo:hover { background:#ffffff;color:#222222 }
        .btnTwo:active { transform: translateY(1px); }
        .mutedTwo { color:#6b7280; font-size: 13px; }
        .spacer { height: 6px; }
        .fileTwos { margin-top: 1px; border: 1px solid #e5e7eb; border-radius: 12px; background:#fff; box-shadow: 0 1px 3px rgba(16,24,40,.06); overflow: hidden; }
        .fileTwo { display:flex; align-items:center; justify-content:space-between; gap:12px; padding: 10px 12px; border-top: 1px solid #f2f4f7; }
        .fileTwo:first-child { border-top: 0; }
        .fileTwo__meta { min-width: 0; }
        .fileTwo__name { margin:0; font-weight:600; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
        .fileTwo__size { margin:2px 0 0; font-size:12px; color:#6b7280; }
        .fileTwo__actions { display:flex; align-items:center; gap:8px; }
        .link { font-size: 14px; text-decoration: underline; text-underline-offset: 3px; color:#111; }
        .chip { padding:6px 10px; border-radius: 999px; border:1px solid #e5e7eb; background:#f9fafb; cursor:pointer; }
        .chip:hover { background:#f3f4f6; }
        .actions { display:flex; gap:10px; justify-content:flex-end; margin-top: 16px; }
        .btnTwo--ghost { background:#fff; color:#111; }
        .btnTwo--primary { background:#4f46e5; border-color:#4f46e5; }
        .btnTwo--primary:hover { background:#4338ca; }
        .errors { margin-top: 12px; background:#fff1f2; border:1px solid #fecdd3; color:#9f1239; padding:10px 12px; border-radius: 10px; font-size: 13px; }
        .errors ul { margin:6px 0 0 18px; }
         
/* md */
@media (min-width: 992px) and (max-width: 1199px) {
   .dropzoneTwo {left:40%;}
 }

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {
 .dropzoneTwo {left:35%;}
} 

/* xs */
@media (max-width: 767px) { .dropzoneTwo {left:25%;bottom:100px}}
.uploader_card__progress{
  margin-top: 12px; 
}

.uploader_card__progress-row{
  display:flex;
  justify-content: space-between;
  font-size: 12px; 
}

.uploader_card__progress-bar{
  height: 8px;width:150px;
  background:#f1f1f1;
  border-radius: 999px;
  overflow: hidden;
  margin-top: 6px;
}

.uploader_card__progress-fill{
  height: 100%;
  background:rgba(144, 202, 249,1) ;;
}

      `}</style>

       <div className="uploaderTwo__wrap">
        
        

        {errors.length > 0 && (
          <div className="errors" style={{position:"relative"}}role="alert">
           
            <ul>
              {errors.map((e, idx) => (
                <li key={idx}>{e}</li>
              ))}
            </ul>
            <div style={{ marginTop: 8 ,}}>
              <div  style={{position:"absolute",top:"10px",right:"10px",cursor:"pointer"}} onClick={clearErrors}><X size={25} color={"#222"}/></div>
            </div>
          </div>
        )}

        <div className="files">
          {files.length === 0 ? (
           <div
          role="button"
          tabIndex={0}
          onClick={openFileDialog}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          className={`dropzoneTwo ${isDragging ? "is-dragging" : ""}`}
          aria-label={`File upload area. Click to select a ${activeType.label} file or drag-and-drop to add.`}
        >
          <input
            ref={inputRef}
            type="file"
            style={{ display: "none" }}
            accept={activeType.accept}
            onChange={(e) => onFilesSelected(e.target.files)}
          />
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="dropzoneTwo__icon">
            <path fillRule="evenodd" d="M19.5 14.25a4.5 4.5 0 01-4.5 4.5h-9A3 3 0 013 15.75v-7.5A3 3 0 016 5.25h7.5a3 3 0 013 3v.75h.75a2.25 2.25 0 012.25 2.25v3zM12 9a.75.75 0 01.75.75v3.69l1.22-1.22a.75.75 0 111.06 1.06l-2.5 2.5a.75.75 0 01-1.06 0l-2.5-2.5a.75.75 0 111.06-1.06l1.22 1.22V9.75A.75.75 0 0112 9z" clipRule="evenodd" />
          </svg>
          <p>Drop {activeType.label} file here</p>
         
          {/* <p className="mutedTwo">or</p> */}
        
        <button type="button" className="btnTwo" onClick={openFileDialog}>Choose file</button>
          <div className="spacer" />
          <p className="mutedTwo">Allowed: {activeType.label} only</p>
        </div>    ) : (
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                  <div className="uploader_card__progress"style={{marginTop:"0px"}}>
<div className="uploader_card__progress-row">

<span style={{color:`#222222`}}>{progress}</span>
</div>
<div className="uploader_card__progress-bar">
<div className="uploader_card__progress-fill" style={{ width: `${progress}%` }} />
</div>
</div>  <button type="button" className="btnTwo" onClick={()=>{setFiles([])}}>Upload New</button>
       
              {/* {files.map((f) => (
                <li key={signature(f)} className="file">
                  <div className="file__meta">
                    <p className="file__name" title={f.name}>{f.name}</p>
                    <p className="file__size">{(f.size / 1024).toFixed(1)} KB</p>
                  </div>
                  <div className="file__actions">
                    <a className="link" href={URL.createObjectURL(f)} target="_blank" rel="noreferrer">Preview</a>
                    <button type="button" onClick={removeFile} className="chip" aria-label={`Remove ${f.name}`}>Remove</button>
                  </div>
                </li>
              ))} */}
            </ul>
          )}
        </div>
        {/* <div className="actions">
          <button type="button" onClick={() => setFiles([])} className="btnTwo btnTwo--ghost">Clear</button>
          <button type="button" onClick={upload} className="btnTwo btnTwo--primary">Upload</button>
        </div> */}

       
      </div>
    </div>
  );
}
